import { render } from "./PaymentSlipHistory.vue?vue&type=template&id=778ee47a&scoped=true"
import script from "./PaymentSlipHistory.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipHistory.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-778ee47a"

export default script